<router-outlet></router-outlet>
<ng-container *ngIf="route.children.length === 0">
  <div class="row">
    <div class="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 text-center">

      <div class="card">
        <div class="content">
          <p>
            Give praise to your colleagues without having to leave slack!
          </p>
          <a [href]="getInstallationUrl()"><img alt="Add to Slack" height="40" width="139"
              src="https://platform.slack-edge.com/img/add_to_slack.png"
              srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" />
          </a>
        </div>
      </div>

    </div>
  </div>
</ng-container>